export enum MAIN_CONTENT_TYPE {
  PDF = 'PDF',
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
}
